import Constants from 'expo-constants'
import { Platform } from 'react-native'
import getEnvValue from './getEnvValue'

/**
 * This allows us to get host ip when running a development build
 * In other cases EXPO_PUBLIC_API_URL needs to point to a correct host IP/domain
 */

export const getApiUrl = () => {
  const env = getEnvValue('API_URL')
  const env_web = process.env.EXPO_PUBLIC_API_URL_WEB

  if (Platform.OS === 'web' && env_web) {
    return env_web
  }

  if (!env) {
    return env
  }
  if (!env.includes('localhost')) {
    return env
  }
  if (!Constants.expoConfig?.hostUri) {
    return env
  }

  const ip = Constants.expoConfig.hostUri.split(':')[0]
  return env.replace('localhost', ip)
}
